"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RainAnimation;

var _react = _interopRequireWildcard(require("react"));

var _RainAnimationModule = _interopRequireDefault(require("./RainAnimation.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function RainAnimation(_ref) {
  var _ref$dropAmount = _ref.dropAmount,
      dropAmount = _ref$dropAmount === void 0 ? 500 : _ref$dropAmount;
  var drops = (0, _react.useMemo)(function () {
    return [];
  }, []);
  var randRange = (0, _react.useCallback)(function (minNum, maxNum) {
    return Math.floor(Math.random() * (maxNum - minNum + 1)) + minNum;
  }, []);
  var createRain = (0, _react.useCallback)(function () {
    var i;

    for (i = 1; i < dropAmount; i += 1) {
      var style = {
        left: randRange(-100, 2000),
        top: randRange(-1000, 1400)
      };

      var node = /*#__PURE__*/_react.default.createElement("div", {
        key: i,
        className: _RainAnimationModule.default.drop,
        style: style
      });

      drops.push(node);
    }
  }, [dropAmount, drops, randRange]);
  createRain();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _RainAnimationModule.default.wrapper
  }, drops);
}